import { render, staticRenderFns } from "./AdvisorDatatableMobileOptimized.vue?vue&type=template&id=8019cad2&scoped=true"
import script from "./AdvisorDatatableMobileOptimized.vue?vue&type=script&lang=js"
export * from "./AdvisorDatatableMobileOptimized.vue?vue&type=script&lang=js"
import style0 from "./AdvisorDatatableMobileOptimized.vue?vue&type=style&index=0&id=8019cad2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8019cad2",
  null
  
)

export default component.exports